<!-- header start -->
<app-header-one [transparent]="true" [white_bg]="true"></app-header-one>
<!-- header end -->

<main>

  <!-- breadcrumb start -->
  <app-breadcrumb-one title="Shop" subtitle="Shop"></app-breadcrumb-one>
  <!-- breadcrumb end -->

  <!-- search area start -->
  <section class="shop__area pt-100 pb-100">
    <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="shop__content-area">
                <div class="shop__header d-sm-flex justify-content-between align-items-center mb-40">
                    <div class="shop__header-left">
                        <div class="show-text">
                            <span>Showing 1–{{products.length > perView ? perView :  products.length}} of {{ products.length }} results </span>
                        </div>
                    </div>
                    <div class="shop__header-right d-flex align-items-center justify-content-between justify-content-sm-end">
                        <div class="sort-wrapper mr-30 pr-25 p-relative">
                          <select [(ngModel)]="sortBy" (ngModelChange)="onSortingChange($event)">
                            <option value="asc">Default Sorting</option>
                            <option value="sale">On Sale</option>
                            <option value="high">Price High To Low</option>
                            <option value="low">Price Low To High</option>
                          </select>
                        </div>
                        <ul class="nav nav-pills" id="pills-tab" role="tablist">
                          <li class="nav-item">
                            <a class="nav-link active" id="pills-grid-tab" data-bs-toggle="pill" href="#pills-grid" role="tab" aria-controls="pills-grid" aria-selected="true"><i class="fas fa-th"></i></a>
                          </li>
                          <li class="nav-item">
                              <a class="nav-link" id="pills-list-tab" data-bs-toggle="pill" href="#pills-list" role="tab" aria-controls="pills-list" aria-selected="false"><i class="fas fa-list-ul"></i></a>
                          </li>
                        </ul>
                    </div>
                </div>

                 <!-- if no item in product  -->
                <div *ngIf="products.length === 0" class="cartmini__empty text-center mt-80">
                  <img src="/assets/img/shop/empty-cart.png" alt="empty-cart-img" />
                  <h4>Sorry! Couldn't find the product you were looking For!!!</h4>
                  <p>Please check if you have misspelt something or try searching with other words.</p>
                  <a routerLink="/shop" class="os-btn os-btn-3">Continue Shopping</a>
                </div>

                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-grid" role="tabpanel" aria-labelledby="pills-grid-tab">
                        <div class="row custom-row-10">
                            <div *ngFor="let item of products.slice(0,perView)" class="col-xl-3 col-lg-3 col-md-6 col-sm-6 custom-col-10">
                                <app-product-item [product]="item"></app-product-item>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-list" role="tabpanel" aria-labelledby="pills-list-tab">
                        <ng-container *ngFor="let item of products.slice(0,perView)">
                          <app-product-list-item [product]="item"></app-product-list-item>
                        </ng-container>
                    </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                      <div class="product__load-btn text-center mt-25">
                          <a *ngIf="perView < products.length" (click)="handlePerView()" class="os-btn os-btn-3 cursor-pointer">Load More</a>
                      </div>
                  </div>
               </div>

            </div>
        </div>
        </div>
    </div>
  </section>
  <!-- search area end -->
</main>

<!-- footer start -->
<app-footer-one></app-footer-one>
<!-- footer end -->
